import { getEmployeesKey, useCreateEmployee } from 'api-hooks/employee';
import { Notification, KIND } from 'baseui/notification';
import { NavigationRoutes } from 'common/constants';
import { PreviousNavigation } from 'common/helpers/previous-navigation';
import { queryClient } from 'common/repositories/query-client';
import notification from 'components/common/notification';
import useGetCrudPermission from 'hooks/use-get-crud-permission';
import useNavigation from 'hooks/use-navigation';
import { SeparatorVertical } from 'legacy-modules/styles';
import * as React from 'react';
import { NavigationProps } from 'types';

import EmployeeForm from './components/form';

export type EmployeeCreateParams = null;

export default function EmployeeCreate(
  props: NavigationProps<NavigationRoutes.EmployeesCreate>,
) {
  const { navigate, back } = useNavigation();

  const { mutateAsync, error } = useCreateEmployee();
  const permission = useGetCrudPermission('employees');
  return (
    <>
      {!!error && !!error.message && (
        <>
          <Notification
            overrides={{
              Body: { style: { width: 'auto', wordBreak: 'break-all' } },
            }}
            kind={KIND.negative}
            closeable
          >
            {() => error.message}
          </Notification>
          <SeparatorVertical $margin={8} />
        </>
      )}
      <EmployeeForm
        {...props}
        onSubmit={async (input, form) => {
          const result = await mutateAsync(input);

          queryClient.refetchQueries([getEmployeesKey()[0]]);

          const prevPath = PreviousNavigation.get();
          if (prevPath) {
            PreviousNavigation.remove();
            back();
          } else if (permission.view) {
            navigate(NavigationRoutes.EmployeesView, {
              id: result.data?.id,
            });
          }

          notification.success({ message: result?.message });

          return result.data;
        }}
      />
    </>
  );
}
